import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetRouteDeliveryScheduleMutationVariables = Types.Exact<{
  input: Types.SetRouteDeliveryScheduleInput;
}>;


export type SetRouteDeliveryScheduleMutation = { __typename?: 'Mutation', setRouteDeliverySchedule: { __typename?: 'RouteDeliveryScheduleConfigPayload', routeDeliveryScheduleConfig?: { __typename?: 'RouteDeliveryScheduleConfigStateData', tenantId: string, entries: Array<{ __typename?: 'RouteDeliveryScheduleEntryData', routeCode: string, deliveryScheduleId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UnsetRouteDeliveryScheduleMutationVariables = Types.Exact<{
  input: Types.UnsetRouteDeliveryScheduleInput;
}>;


export type UnsetRouteDeliveryScheduleMutation = { __typename?: 'Mutation', unsetRouteDeliverySchedule: { __typename?: 'RouteDeliveryScheduleConfigPayload', routeDeliveryScheduleConfig?: { __typename?: 'RouteDeliveryScheduleConfigStateData', tenantId: string, entries: Array<{ __typename?: 'RouteDeliveryScheduleEntryData', routeCode: string, deliveryScheduleId: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetRouteDeliveryScheduleDocument = new TypedDocumentString(`
    mutation SetRouteDeliverySchedule($input: SetRouteDeliveryScheduleInput!) {
  setRouteDeliverySchedule(input: $input) {
    routeDeliveryScheduleConfig {
      ...RouteDeliveryScheduleConfigStateDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment RouteDeliveryScheduleConfigStateDetails on RouteDeliveryScheduleConfigStateData {
  tenantId
  entries {
    routeCode
    deliveryScheduleId
  }
}`);
export const UnsetRouteDeliveryScheduleDocument = new TypedDocumentString(`
    mutation UnsetRouteDeliverySchedule($input: UnsetRouteDeliveryScheduleInput!) {
  unsetRouteDeliverySchedule(input: $input) {
    routeDeliveryScheduleConfig {
      ...RouteDeliveryScheduleConfigStateDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment RouteDeliveryScheduleConfigStateDetails on RouteDeliveryScheduleConfigStateData {
  tenantId
  entries {
    routeCode
    deliveryScheduleId
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetRouteDeliverySchedule: build.mutation<SetRouteDeliveryScheduleMutation, SetRouteDeliveryScheduleMutationVariables>({
      query: (variables) => ({ document: SetRouteDeliveryScheduleDocument, variables })
    }),
    UnsetRouteDeliverySchedule: build.mutation<UnsetRouteDeliveryScheduleMutation, UnsetRouteDeliveryScheduleMutationVariables>({
      query: (variables) => ({ document: UnsetRouteDeliveryScheduleDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetRouteDeliveryScheduleMutation, useUnsetRouteDeliveryScheduleMutation } = injectedRtkApi;
